import { render } from "./BulkRecycleRfid.vue?vue&type=template&id=7dc17a59&scoped=true"
import script from "./BulkRecycleRfid.vue?vue&type=script&lang=ts"
export * from "./BulkRecycleRfid.vue?vue&type=script&lang=ts"

import "./BulkRecycleRfid.vue?vue&type=style&index=0&id=7dc17a59&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7dc17a59"

export default script